import * as React from 'react';
import { Product, CartProduct as ICartProduct } from '../models/interfaces';
import CartProduct from './CartProduct';

export interface CartProps {
  products: Array<ICartProduct>;
  addProduct: (product: Product, amount: number) => void;
  subtractProduct: (product: Product, amount: number) => void;
  removeProduct: (product: Product) => void;
  changeProductQuantity: (product: Product, quantity: number) => void;
}

class Cart extends React.Component<CartProps> {

  constructor(props: CartProps) {
    super(props);
  }

  getProducts() {
    const {
      products,
      addProduct,
      subtractProduct,
      removeProduct,
      changeProductQuantity } = this.props;

    if (products.length) {
      return products.map(product =>
        (
          <CartProduct
            key={product.Key}
            cartProduct={product}
            removeProduct={removeProduct}
            addProduct={addProduct}
            subtractProduct={subtractProduct}
            changeProductQuantity={changeProductQuantity}
          />
        )
      );
    }

    return <div className="empty">Tilauksessa ei ole tuotteita</div>;
  }
  // Reusing product-list theme for cart.
  render() {
    return (
      <div className="cart product-list product-list--table">
        {
          this.getProducts()
        }
      </div>
    );
  }
}

export default Cart;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Cart.tsx